import React from 'react';
export const useCopyToClipboard = () => {
    const [hasCopied, setHasCopied] = React.useState(false);
    const copyToClipboard = async (text) => {
        if ('clipboard' in navigator) {
            await navigator.clipboard.writeText(text);
            setHasCopied(true);
            setTimeout(() => setHasCopied(false), 1000);
        }
        return false;
    };
    const copy = React.useCallback(async (text) => {
        if (!hasCopied) {
            await copyToClipboard(text);
        }
    }, [hasCopied]);
    React.useEffect(() => () => setHasCopied(false), []);
    return { hasCopied, copy };
};
